import * as React from "react";
import { cn } from "@/lib/utils";

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
};

export const PageHeader: React.FC<Props> = ({
  eyebrow,
  title,
  description,
  actions,
  className,
}) => {
  return (
    <header
      data-testid="page-header"
      className={cn(
        "flex flex-col gap-5 border-b border-border pb-7 md:flex-row md:items-end md:justify-between",
        className,
      )}
    >
      <div className="max-w-2xl space-y-2">
        {eyebrow ? (
          <span className="eyebrow" data-testid="page-eyebrow">
            {eyebrow}
          </span>
        ) : null}
        <h1
          data-testid="page-title"
          className="font-serif text-4xl font-500 leading-[1.05] text-foreground sm:text-5xl"
        >
          {title}
        </h1>
        {description ? (
          <p
            data-testid="page-description"
            className="text-base text-muted-foreground sm:text-lg"
          >
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </header>
  );
};
